export enum FilterTypeEnum {
  DATE = 'date',
  TEXT = 'text',
  SEARCHABLE_TEXT = 'searchableText',
  TOGGLE = 'toggle',
  DATE_LINE = 'date-line',
  DATE_PICKER = 'date-picker',
}
